module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="phx-resultcontroles-detail">\r\n  <div class="phx-resultcontroles-header">\r\n    <div class="collab ctxGestionCollab"></div>\r\n    <div class="etat ui-phx-ihm-texte-erreur-important"></div>\r\n    <div class="periode"></div>\r\n    <br><br>\r\n  </div>\r\n  <div class="phx-resultcontroles-tablesaisie"></div>\r\n  <div class="phx-resultcontroles-tablerecap"></div>\r\n  <div class="phx-resultcontroles-buttons"></div>\r\n  <br>\r\n  <br>\r\n</div>';
}
return __p;
};
